import { gql, useQuery } from '@apollo/client';

export const DPO_INFO_FIELDS = gql`
  fragment DpoInfoFields on DpoInfo {
    userId
    name
    email
    phone
    address
    company
    avatarUrl
    isComplete
  }
`;

export const GetDpoInfo = gql`
  ${DPO_INFO_FIELDS}
  query GetDpoInfo($companyId: String!) {
    getDpoInfo(companyId: $companyId) {
      ...DpoInfoFields
    }
  }
`;

export const GET_DPO_INFO = GetDpoInfo;

export interface DpoInfo {
  userId: string | null;
  name: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  company: string | null;
  avatarUrl: string | null;
  isComplete: boolean;
}

export interface GetDpoInfoResult {
  getDpoInfo: DpoInfo;
}

export interface GetDpoInfoInput {
  companyId: string;
}

export function useDpoInfoQuery(companyId: string | undefined) {
  return useQuery<GetDpoInfoResult, GetDpoInfoInput>(GET_DPO_INFO, {
    variables: { companyId: companyId || '' },
    skip: !companyId,
  });
}
